<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {useAuth, useAsyncData} from '#imports';

    const {isLogged} = useAuth();
    await useAsyncData('isLogged', () => isLogged(), {dedupe: 'defer', deep: true});
</script>
